import { type Registry as Services, service } from '@ember/service';
import type Transition from '@ember/routing/transition';
import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';
import { scrollRhsToTop } from 'uplisting-frontend/pods/-sidebar/utils';
import type ProtectionDisputesDisputeController from 'uplisting-frontend/pods/protection/disputes/dispute/controller';

export interface IParams extends Record<string, unknown> {
  dispute_id: string;
}

export default class ProtectionDisputesDisputeRoute extends ProtectedRoute {
  @service('repositories/dispute')
  disputeRepository!: Services['repositories/dispute'];

  model(params: IParams) {
    return this.disputeRepository.findRecord(params.dispute_id, {
      reload: true,
    });
  }

  setupController(
    controller: ProtectionDisputesDisputeController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { dispute: model });

    scrollRhsToTop(this);
  }
}
